import Vue from 'vue'

export const UserLogin = function (params) {
  return Vue.prototype.$axios.post('/operator/login', params)
}

export const UserLogout = function () {
  return Vue.prototype.$axios.get('/operator/logout')
}
// 通过管理后台token交换进行登录
export const UserTokenLogin = function (params) {
  return Vue.prototype.$axios.get('/operator/token/getShopTokenByOperatorToken?operatorToken=' + params)
}
// yiwu登录
export const yiwuTokenLogin = function (params) {
  return Vue.prototype.$axios.get('/operator/loginByYiWu?accessToken=' + params)
}



// WEBPACK FOOTER //
// ./src/services/login.js